const external = cornerstoneTools.external;
const BaseTool = cornerstoneTools.importInternal('base/BaseTool');
// import external from '../externalModules.js';
// import BaseTool from './base/BaseTool.js';
const removeToolState = cornerstoneTools.removeToolState;
const getToolState = cornerstoneTools.getToolState;
// import { getToolState, removeToolState } from '../stateManagement/toolState.js';
const state = cornerstoneTools.store.state;
// import { state } from '../store/index.js';
// import { eraserCursor } from './cursors/index.js';
const cursors = cornerstoneTools.import('tools/cursors');
const eraserCursor = cursors.eraserCursor;

import { HistoricToolDataService } from "src/app/services/historic-tool-data.service";

/**
 * @public
 * @class EraserTool
 * @memberof Tools
 *
 * @classdesc Tool for deleting the data of other Annotation Tools.
 * @extends Tools.Base.BaseTool
 */
export default class EraserTool extends BaseTool {
  constructor(props = {}) {
    const defaultProps = {
      name: 'Eraser',
      supportedInteractionTypes: ['Mouse', 'Touch'],
      svgCursor: eraserCursor,
    };

    super(props, defaultProps);

    this.preMouseDownCallback = this._deleteAllNearbyTools.bind(this);
    this.preTouchStartCallback = this._deleteAllNearbyTools.bind(this);
  }

  _deleteAllNearbyTools(evt) {
    const coords = evt.detail.currentPoints.canvas;
    const element = evt.detail.element;

    state.tools.forEach(function (tool) {
      const toolState = getToolState(element, tool.name);

      if (toolState != null) {
        const foundState = toolState.data.find(d => typeof tool.pointNearTool === 'function' && tool.pointNearTool(element, d, coords))
        console.log('foundState', foundState);
        if (foundState != null) {
          removeToolState(element, tool.name, foundState);
          element.dispatchEvent(new Event(cornerstoneTools.EVENTS.MEASUREMENT_COMPLETED));
          HistoricToolDataService.getInstance().setRemoved(element, tool.name, foundState);
          external.cornerstone.updateImage(element);
        }
      }
    });
    const consumeEvent = true;
    return consumeEvent;
  }
}